import type { ProductVM } from "./mappers";
import { C, tabular } from "./theme";
import { Card, InfoGrid } from "./shared/Card";
import { ProductPill } from "./shared/ProductPill";

/** responseCode "09" (or a report without any credit sections). */
export const HdcEmptyState = ({ product }: { product: ProductVM }) => (
  <div
    style={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(min(300px, 100%), 1fr))",
      gap: 20,
      maxWidth: 1100,
    }}
  >
    <Card title="Consulta" aside={<ProductPill product={product} />}>
      <InfoGrid
        items={[
          { label: "Fecha de consulta", value: product.consultDate },
          {
            label: "Código de seguridad",
            value: product.securityCode,
            valueStyle: tabular,
          },
          { label: "Documento", value: product.document },
          { label: "Ejecución del paso", value: product.executionDatetime },
        ]}
      />
    </Card>
    <Card style={{ flexDirection: "row", gap: 16, alignItems: "flex-start" }}>
      <svg
        role="img"
        aria-label="Información"
        width="28"
        height="28"
        viewBox="0 0 24 24"
        fill="none"
        stroke={C.warn}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ flex: "none" }}
      >
        <circle cx="12" cy="12" r="10" />
        <path d="M12 16v-4" />
        <path d="M12 8h.01" />
      </svg>
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        <span style={{ fontSize: 15, fontWeight: 700, color: C.white }}>
          La persona no registra historial en Experian
        </span>
        <span style={{ fontSize: 13, lineHeight: 1.55, color: C.text }}>
          Experian solo retornó el resultado de la consulta y la identificación.
          No hay obligaciones, tarjetas, score ni endeudamiento global que
          mostrar; las demás secciones del reporte se ocultan.
        </span>
      </div>
    </Card>
  </div>
);
